<template>
  <div class="home-page">
    <HomeHero />
    <IntelligentVideoStory />
    <DeploymentSequence />
    <OperationalProof />
    <TechnicalSurface />
    <ApplicationStories />
    <BrandValue />
    <TrustSequence />

    <section class="cta-section">
      <div class="cta-content">
        <h2>Ready to See What's Below?</h2>
        <p>
          Join organizations around the world using Fathom Ocean to observe,
          protect, and understand underwater environments in real time.
        </p>

        <b-button @click="$router.push('/contact')">
          Request a Consultation
        </b-button>
      </div>
    </section>
  </div>
</template>

<script>
import HomeHero from '@/components/journey/HomeHero.vue'
import IntelligentVideoStory from '@/components/journey/IntelligentVideoStory.vue'
import DeploymentSequence from '@/components/journey/DeploymentSequence.vue'
import OperationalProof from '@/components/journey/OperationalProof.vue'
import TechnicalSurface from '@/components/journey/TechnicalSurface.vue'
import ApplicationStories from '@/components/journey/ApplicationStories.vue'
import BrandValue from '@/components/journey/BrandValue.vue'
import TrustSequence from '@/components/journey/TrustSequence.vue'

export default {
  name: 'Main',
  components: {
    HomeHero,
    IntelligentVideoStory,
    DeploymentSequence,
    OperationalProof,
    TechnicalSurface,
    ApplicationStories,
    BrandValue,
    TrustSequence,
  },
}
</script>
